/**
 * Created by amine on 05/09/2019.
 */
(function () {
    'use strict';

    const getObjectId = require('../../../shared/utils/get-object-id');

    class EntryPrePaymentDialogCtrl {
        constructor($mdDialog, $q, $translate, paymentService, visitService, frontDeskService, configService, moment, system, $scope) {
            this.dialog = $mdDialog;
            this.$q = $q;
            this.$translate = $translate;
            this.paymentService = paymentService;
            this.frontDeskService = frontDeskService;
            this.visitService = visitService;
            this.moment = moment;
            this.dateFormat = system['date_format'].js;
            this.$scope = $scope;

            this.advancePrepayment = configService.hasAdvancePrepayment()

            this.encasement = {
                procedures: [],
                financial_status: {
                    global_discount: 0,
                    global_percentage_discount: 0,
                    gross_total: 0,
                    total: 0,
                    is_validated: false
                }
            };
        }

        static get $inject() {
            return ["$mdDialog", "$q", "$translate", "paymentService", "visitService", "frontDeskService", "configService", "moment", "system", "$scope"];
        }

        $onInit() {
            this.entry = this.entry || null;
            this.patientId = this.patientId || -1;
            if (this.entry) {
                this._initializeWithEntry();
            } else if (this.patientId && this.patientId !== -1) {
                this._initializeWithPatientId();
            }

            if(this.advancePrepayment){
                this.$scope.$watch(() => this.total(true), (newTotal) => {
                    if (newTotal !== undefined && newTotal !== null) {
                        this.totalAmount = newTotal;
                            this.encasement.total_amount = newTotal;
                    }
                });
                this.totalAmount = this.total(true);
            }
            
        }

        _initializeWithEntry() {
            if (this.entry.has_encasement) {
                this.paymentService.getEncasement(this.entry.encasement)
                    .then(encasement => {
                        this.encasement = Object.assign(this.encasement, encasement);
                        this._ensureStructure();
                    });
            } else {
                this._createEncasementFromEntry();
            }
        }

        _initializeWithPatientId() {
            let payee = {
                _module: "patient.models",
                _model: "Patient",
                id: this.patientId
            };

            Object.assign(this.encasement, {
                payer: payee,
                payer_type: "P",
                payee: payee,
                payee_type: "P",
                encasement_date: this.moment().format(this.dateFormat),
                total_amount: 0,
                pre_encasement: true,
                physician: null,
                payment_mode: {
                    due_date: this.moment().format(this.dateFormat)
                }
            });

            this._ensureStructure();
        }

        _createEncasementFromEntry() {
            let payee = {
                _module: "patient.models",
                _model: "Patient",
                id: this.entry.patient.id
            };

            Object.assign(this.encasement, {
                payer: payee,
                payer_type: "P",
                payee: payee,
                payee_type: "P",
                encasement_date: this.moment().format(this.dateFormat),
                total_amount: 0,
                pre_encasement: true,
                physician: _.get(this.entry, 'physician'),
                payment_mode: {
                    due_date: this.moment().format(this.dateFormat)
                }
            });

            this._ensureStructure();
        }

        _ensureStructure() {
            if (!this.encasement.procedures) {
                this.encasement.procedures = [];
            }

            if (!this.encasement.financial_status) {
                this.encasement.financial_status = {
                    global_discount: 0,
                    global_percentage_discount: 0,
                    gross_total: 0,
                    total: 0,
                    is_validated: false
                };
            }
        }

        cancel() {
            this.dialog.cancel();
        }

        payerChange() {
            const patientId = this.entry ? this.entry.patient.id : this.patientId;

            let patient = {
                _module: "patient.models",
                _model: "Patient",
                id: patientId
            };

            switch (this.encasement.payer_type) {
                case "P":
                    this.encasement = _.assign(this.encasement, {payer: patient});
                    break;
                case "O":
                    this.encasement = _.assign(this.encasement, {payer: this.paymentService.getCls("unregistered")});
                    break;
            }
        }

        total(net = false) {
            const hasFinancial = !!this.encasement && !!this.encasement.financial_status;
            const globalDiscount = hasFinancial ? Number(_.get(this.encasement, "financial_status.global_discount", 0)) : 0;

            let start = 0;
            if (this.encasement && this.encasement.delivery_document) {
                const deliveryDocumentTaxedTotal = Number(_.get(this.encasement, "delivery_document.taxed_total", 0));
                start = deliveryDocumentTaxedTotal;
            }

            const proceduresTotal = _.reduce(this.encasement.procedures || [], (result, item) => {
                return result + item['qte'] * (item['price'] - item['discount']);
            }, 0);

            const gross = start + proceduresTotal;
            const total = net ? (gross - globalDiscount) : gross;

            return _.isNaN(total) ? 0 : total;
        }

        submit() {
            if (this.encasement.delivery_document &&
                this.encasement.delivery_document.lines &&
                this.encasement.delivery_document.lines.length === 0) {
                _.unset(this.encasement, 'delivery_document');
            }

            return this.paymentService.saveEncasement(_.assign(this.encasement, {transaction_uid: getObjectId()}))
                .then(data => {
                    this.encasement.id = _.get(data, "id")
                    if (this.entry) {
                        return this.frontDeskService.partialUpdateEntry({
                            id: this.entry.id,
                            encasement: this.encasement.id
                        });
                    } else {
                        return data;
                    }
                })
                .then(result => {
                    this.dialog.hide(result);
                    return result;
                })
        }
    }

    module.exports = {
        controller: EntryPrePaymentDialogCtrl,
        template: require("./entry-pre-payment.tpl.html"),
        controllerAs: "vm",
        bindToController: true,
        multiple: true,
        parent: $(document.body),
        clickOutsideToClose: true,
    };
})();